import call from "@/service/http";
import AuthConstants from "./authConstants";
import eventBus from "@/utils/eventBus";
import AuthService from "../auth/views/authService";

const authModule = {
  namespaced: true,
  state: {

  },
  mutations: {


    MUTATE: (state, payload) => {
      state[payload.state] = payload.value;
    },
  },
  getters: {
    // alert: (state) => state.alert,
    authGetters: (state) => (val) => state[val],
  },
  actions: {
    login: (_, data) => {
      call("post", AuthConstants.login, data)
        .then((res) => {
          if (res.data.status_code === 200) {
            AuthService.login(res.data.access);
            eventBus.emit("showToast", {
              type: "success",
              message: res.data.message,
            });
          } else {

            eventBus.emit("showDialog", {
              type: "error",
              message: "Invalid credentials",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          eventBus.emit("showDialog", {
            type: "error",
            message: "Invalid credentials",
          });
        });
    },

    loginwithOtp: (_, data) => {
      call("post", AuthConstants.loginwithotp, data)
        .then((res) => {
          if (res.data.status_code === 200) {
            localStorage.setItem("otp_token", res.data.user_id);
            // AuthService.login(res.data.access);
            eventBus.emit("showOtpPage", {
              type: "success",
              message: res.data.message,
            });
          } else {

            eventBus.emit("showDialog", {
              type: "error",
              message: "Invalid credentials",
            });
          }
        })
        .catch((err) => {
          localStorage.setItem("err", err);
          console.log(err);
          eventBus.emit("showDialog", {
            type: "error",
            message: "Invalid credentials",
          });
        });
    },

    VERIFYOtp: (_, data) => {
      call("post", AuthConstants.VERIFYotp, data)
        .then((res) => {
          if (res.data.status_code === 200) {
            // localStorage.setItem("otp_token", res.data.user_id);
            AuthService.login(res.data.access);
            // eventBus.emit("showOtpPage", {
            //   type: "success",
            //   message: res.data.message,
            // });
          } else {

            eventBus.emit("showDialog", {
              type: "error",
              message: "Otp cancelled or expired",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          eventBus.emit("showDialog", {
            type: "error",
            message: "Otp cancelled or expired",
          });
        });
    },

forgot: (_, data) => {
  return call("post", AuthConstants.forgot, data)
    .then((res) => {
      if (res.data.status_code === 200) {
        eventBus.emit("showDialog", {
          type: "success",
          message: res.data.message,
        });
      } else {
        eventBus.emit("showToast", {
          type: "error",
          message: res.data.message,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      eventBus.emit("showToast", {
        type: "error",
        message: "Error resending password reset link",
      });
    });
},

    newpassword: (_, data) => {
      call("post", AuthConstants.newpassword(data.token), data.pass)
        .then((res) => {
          console.log(res.data); // Log the entire response data

          // Assuming res.data.message exists in the response
          eventBus.emit("showToast", {
            type: "success",
            message: res.data.message,  // Use res.data to access the message
          });
          eventBus.emit("redirectback");
        })
        .catch((err) => {
          console.log(err); // Log the error

          if (err.response) {
            // Handle error response here
            eventBus.emit("showToast", {
              type: "error",
              message: err.response.data.message || "An error occurred", // Provide fallback
            });
          } else {
            eventBus.emit("showToast", {
              type: "error",
              message: "An error occurred while processing your request.",
            });
          }
        });
    },


    reset: ({ commit }, data) => {
      call("post", AuthConstants.reset, data)
        .then((res) => {
          console.log(res);
          commit("SET_ALERT", {
            status: "success",
            message: "success",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    acceptInvite: (_, data) => {
      call("post", AuthConstants.invite(data.token), data)
        .then((res) => {
          if (res.data.status_code === 200) {
            eventBus.emit("showToast", {
              type: "success",
              message: "wait as we redirect you to login",
            });
            eventBus.emit("acceptInvite");
          } else {
            eventBus.emit("showToast", {
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};

export default authModule;
